import React from "react";
import { Table } from "semantic-ui-react";

export const getLocateplusBrand = () => (
  <Table className="table-no-border-and-padding background-color-transparent">
    <Table.Body>
      <Table.Row>
        <Table.Cell className="finest-color">
          Finest Investigative Database over 100,000 users
        </Table.Cell>
        <Table.Cell className="locate-vip-support">
          VIP Support 1-888.746.3463
        </Table.Cell>
      </Table.Row>
    </Table.Body>
  </Table>
);

export const getEntersectBrand = () => (
  <div>Customer Service: 1.877.482.0101</div>
);

export const getLpPoliceBrand = () => (
  <div>Customer Service: 1.877.482.0101</div>
);



// WEBPACK FOOTER //
// ./src/components/navigation/Brand.js